/* eslint-disable no-shadow */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-negated-condition */
import React, { useEffect, useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { FSBTable } from 'components/common/FSBTable';
import Loader from 'components/common/Loader';
import ActionsFormatter from 'components/ActionsFormatter';
import { ADD_EDIT_CONSTANT, defaultDeleteFilter } from 'utils/constants';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import {
  SUBSCRIPTION_PLANS_QUERY,
  UPDATE_SUBSCRIPTION_PLAN,
} from 'pages/SubscriptionPlans/subscriptionPlanGraphQL';
import { addOnColumns } from 'pages/Addons/constants';
import { toast } from 'react-toastify';
import { FaCheck } from 'react-icons/fa6';
import SubscriptionPlanMobileList from 'pages/SubscriptionPlans/components/SubscriptionPlanMobileList';

const IndianAddonsTable = ({
  searchString,
  toggleDeleteRecord,
  handleClickEdit,
}) => {
  const [filters, setFilters] = useState({
    // filter: [{ ...defaultDeleteFilter }],
    filter: [
      {
        key: 'planName',
        // joinAttributeName: '',
        value: searchString,
        type: 'STRING',
        op: 'LIKE',
      },
      {
        key: 'isAddOn',
        value: true,
        type: 'BOOLEAN',
        op: 'EQ',
      },
      {
        key: 'currency',
        value: 'INR',
        type: 'STRING',
        op: 'EQ',
      },
      { ...defaultDeleteFilter },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
    pagination: true,
  });

  const { data, loading, error, refetch } = useQuery(SUBSCRIPTION_PLANS_QUERY, {
    variables: {
      ...filters,
      filter: [...filters.filter],
    },
    fetchPolicy: 'network-only',
  });

  const [updateSubscriptionPlan] = useMutation(UPDATE_SUBSCRIPTION_PLAN, {
    onCompleted: ({ updateSubscriptionPlan }) => {
      toast.success(updateSubscriptionPlan?.message);
      refetch();
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });
  const handleStatusChange = async (row) => {
    try {
      await updateSubscriptionPlan({
        variables: {
          updateInput: {
            id: row.id,
            status: row?.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
          },
          subscriptionPlanPriceHistoryInputDTO: {
            subscriptionPlan: row?.id,
          },
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  const statusFormatter = (cell) => {
    return (
      <div className="toggle-check cmn-toggle d-flex">
        <span className="d-inline-block position-relative">
          <input
            type="checkbox"
            onChange={() => handleStatusChange(cell?.row?.original)}
            checked={cell?.row?.original?.status === 'ACTIVE' ? true : false}
          />
          <FaCheck size={10} />
        </span>
      </div>
    );
  };

  const actionsFormatter = (cell) => {
    return (
      <ActionsFormatter
        isView={false}
        handleDelete={() =>
          toggleDeleteRecord(cell?.row?.original?.id, refetch)
        }
        handleEdit={() =>
          handleClickEdit(cell?.row?.original, ADD_EDIT_CONSTANT.EDIT, refetch)
        }
      />
    );
  };

  const findIndexOfItem = (item) => {
    return addOnColumns.findIndex((itm) => itm.accessorKey === item);
  };

  addOnColumns[findIndexOfItem('actions')].cell = actionsFormatter;
  addOnColumns[findIndexOfItem('status')].cell = statusFormatter;

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: data?.subscriptionPlans?.totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };
  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  useEffect(() => {
    const updatedFilter = [...filters.filter]; // Clone the filter array
    const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
    updatedFirstFilter.value = searchString;
    updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
    // return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
    refetch({ ...filters, filter: updatedFilter });
  }, [searchString]);

  // const onGlobalSearch = (str) => {
  //   if (str) {
  //     setFilters((prevFilter) => {
  //       const updatedFilter = [...prevFilter.filter]; // Clone the filter array
  //       const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
  //       updatedFirstFilter.value = str;
  //       updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
  //       return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
  //     });
  //   }
  // };

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.subscriptionPlans?.subscriptionPlans)
    return <NoDataFound message="Subcription Plans not available" />;

  return (
    <>
      <SubscriptionPlanMobileList
        plans={(data && data?.subscriptionPlans?.subscriptionPlans) || []}
        totalPages={(data && data?.subscriptionPlans?.totalPages) || 0}
        currentPageNo={filters.pageNo}
        pageSize={filters.pageSize}
        handlePageChange={handlePageChange}
        renderActions={(plan) => actionsFormatter({ row: { original: plan } })}
        renderStatus={(plan) => statusFormatter({ row: { original: plan } })}
      />
      <div className="subscription-mobile-hide-table">
        <FSBTable
          data={(data && data?.subscriptionPlans?.subscriptionPlans) || []}
          totalCount={(data && data?.subscriptionPlans?.totalCount) || 0}
          totalPages={(data && data?.subscriptionPlans?.totalPages) || 0}
          columns={addOnColumns}
          currentPageNo={filters.pageNo}
          pageSize={filters.pageSize}
          keyField="id"
          showSearch={false}
          showFilters={false}
          showDelete={false}
          showPagination
          remote
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="table-responsive word-break"
          handlePageChange={handlePageChange}
          // globalSearchStr={filters.filter[0].value}
          // onGlobalSearch={onGlobalSearch}
          onSortChange={onSortChange}
          sorting={sortBy}
          searchPlaceholder="Search "
        />
      </div>
    </>
  );
};
export default IndianAddonsTable;
